import { Button } from "@mui/material"

export default function OutlinedButton(props: any) {
  return (
    <Button
      style={{
        borderRadius: "26px",
        color: "#072D26",
        fontWeight: "bold",
        border: "2px solid #C0D904",
        maxWidth: "300px",
        height: "51px",
        padding: "0px 42px",
      }}
      variant="outlined"
      {...props}
    >
      {props.children}
    </Button>
  )
}